import { PAYMENTS_GRID } from './paymentsTableLayout'

const columns = [
  'Customer',
  'Booking ID',
  'Service',
  'Amount',
  'Payment Method',
  'Status',
  'Date & Time',
  'Actions',
] as const

export const PaymentsTableHeader = () => (
  <div
    className="grid items-start justify-between font-host text-[14px] font-medium leading-normal text-dash-col-head"
    style={{ gridTemplateColumns: PAYMENTS_GRID }}
  >
    {columns.map((label) => (
      <span
        key={label}
        className={
          label === 'Payment Method' ||
          label === 'Status' ||
          label === 'Date & Time' ||
          label === 'Actions'
            ? 'text-center'
            : undefined
        }
      >
        {label}
      </span>
    ))}
  </div>
)
